/*!Copyright 2010 karmadata, Inc. **/
/**kd.api.data requires
* jQuery
* Underscore.js
* moment.js
* var foo = kd.Request('Investigator','Search');
* var bar = foo.Request('Investigator','Search')
*/
/**kd.api.data.Request is the controller that:
*1. Handles the ajax request for data for a common EntityType
*2. Knows the EntityType in context
*3. Has a list (must have at least one) of kd.api.data.Request
*4. Has a kd.api.data.SortOrder wrapping the list of Requests for a common entityType
*5. Has a kd.api.data.Page wrapping the list of Requests that works with the SortOrder
*/

var _ = {}
_.each = require('lodash.foreach')
_.indexOf = require('lodash.indexof')
_.flattenDeep = require('lodash.flattendeep')

var filterlib = require('./kd.api.data.Filter')
var groupbylib = require('./kd.api.data.GroupBy')
var pagelib = require('./kd.api.data.Page')
var sortorderlib = require('./kd.api.data.SortOrder')

var Filter = filterlib.Filter
var GroupByList = groupbylib.GroupByList
var Page = pagelib.Page
var SortOrder = sortorderlib.SortOrder


var Request = (function () {
    return function (queryEntityActionIn, queryEntityTypeIn) {
        /**The kd.api.data.Request wraps a list of RequestItems for the same EntityType
        *The Order and Pagination lives here
        *The Action, Filters, Aggregations live in the kd.api.data.RequestItem
        *For convenience, we instantiate the initial RequestItem and add it to the requestList for Post body
        */
        //Private Variables
        /**The entity type that is being requested*/
        var entityType = queryEntityTypeIn;
        /**The action that is being requested - AutoComplete|Search*/
        var entityAction = queryEntityActionIn;
        /**see kd.api.data.RequestItem.js
        *the initial RequestItem is added to the RequestItemList and serves as the first request via init(), though it can be later replaced
        */
        var primaryRequestItem;
        /**see kd.api.data.RequestItemList.js
        *The api user can send as many different requests for data about an EntityType as s/he pleases
        *however the requests need to be tied with the same EntityType
        */
        var requestItemList;
        /**see kd.api.data.SortOrder.js
        * A list of properties to be order the results (server side API ordering)
        * start and rowsPerPage control pagination
        */
        var orderByList;
        /**see kd.api.data.Page.js
        * start and rowsPerPage control pagination
        */
        var pagination;
        /**
        *The apikey and url control resource requests and access
        */
        var urlBase;
        var url;
        var apiKey;
        var authToken;

        var protocol = 'https';
        /**
        *The kdResponse holds the response from the current ajax request
        */
        var kdResponse;
        /**
        *The ajaxRequest makes the request, stores the data to a private variable, and implements any custom logic set in event handlers
        */

        var ajaxBeforeSend;
        var ajaxDone;
        var ajaxFail;
        var ajaxRequestNewPage;

        //Private Functions
        var setUrl = function () {
            var start = pagination.getPageStart();
            var rowsPerPage = pagination.getPageRows();

            if(entityAction === "Group"){
                url = urlBase + "/Group" + "?Start=" + start + "&RowsPerPage=" + rowsPerPage;

            } else if(entityAction === "Search"){
                url = urlBase + "/Search" + "/" + entityType + "?Start=" + start + "&RowsPerPage=" + rowsPerPage;

            } else if(entityAction === "Select"){
                url = urlBase + "/Select" + "?Start=" + start + "&RowsPerPage=" + rowsPerPage;

            }
            else {
                throw "A valid API Action is required.  Group, Search, Select are the valid Actions";

            }

            if(apiKey){
                url = url + "&apikey=" + apiKey
            }
        }

        var getUrl = function () {
            setUrl();
            return url;
        };


        var getRequestValue = function () {
            var value = {};

            if (requestItemList) {
                var requestItemListStruct = requestItemList.getRequestItemListValue();
                value.RequestItemList = requestItemListStruct;
            }
            if (orderByList) {
                var orderByListStruct = orderByList.getSortOrderModelValue();
                value.OrderByList = orderByListStruct;
            }

            return value;
        };

        var getNewPageAjax = function () {
            var apiUrl = getUrl();

            var xhr = new window.XMLHttpRequest()
            xhr.open('POST', apiUrl, true)
            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8')
            if (authToken) xhr.setRequestHeader('Authorization', 'Bearer ' + authToken)
            // xhr.setRequestHeader('Accpet', 'application/json')
            xhr.onload = function() {
              if (xhr.status >= 200 && xhr.status < 300) {
                try {
                  var data = JSON.parse(xhr.responseText)
                  kdResponse = data
                  if (ajaxDone) ajaxDone(data)
                } catch(e) {
                  if (ajaxFail) ajaxFail(xhr, null, e)
                }
              } else {
                if (ajaxFail) ajaxFail(xhr)
              }
            }
            if (ajaxBeforeSend) ajaxBeforeSend(xhr)
            xhr.send(JSON.stringify(getRequestValue()))
        };

        var init = function() {
            /**Flag the current objects for Garbage Collection*/
            primaryRequestItem = null;
            requestItemList = null;
            orderByList = null;
            pagination = null;
            url = null;
            authToken = null;
            /**Re-instantiate the primary Request Item and the backing List*/
            primaryRequestItem = new RequestItem(entityAction);
            requestItemList = new RequestItemList(entityType);
            requestItemList.addRequestItem(primaryRequestItem);

            /**Re-instantiate the Order and Pagination*/
            orderByList = new SortOrder();
            pagination = new Page();

            /**NOTE, THIS REQUIRES THE APP DEVELOPER TO REBIND THE MODELS TO VIEWS
            * AND TO RE-REGISTER THE ORDER AND PAGINATION MV PAIRS WITH THIS CONTROLLER
            */


            setUrl();
        };

        //Public Variables
        this.IsRequest = true;

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.setAjaxBeforeSend = function (ajaxBeforeSendIn) {
            ajaxBeforeSend = ajaxBeforeSendIn;
        };
        this.setAjaxDone = function (ajaxDoneIn) {
            ajaxDone = ajaxDoneIn;
        };
        this.setAjaxFail = function (ajaxFailIn) {
            ajaxFail = ajaxFailIn;
        };

        this.setApiKey = function (apiKeyIn) {
            apiKey = apiKeyIn;
            setUrl();
        };

        this.setAuthToken = function (token) {
          authToken = token;
        }

        this.requestData = function () {
            pagination.setPageStart(1); //only needed for a new search
            var apiUrl = getUrl();

            var xhr = new window.XMLHttpRequest()
            xhr.open('POST', apiUrl, true)
            xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8')
            if (authToken) xhr.setRequestHeader('Authorization', 'Bearer ' + authToken)
            // xhr.setRequestHeader('Accpet', 'application/json')
            xhr.onload = function() {
              if (xhr.status >= 200 && xhr.status < 300) {
                try {
                  var data = JSON.parse(xhr.responseText)
                  kdResponse = data
                  pagination.setResultCount(data.KdResult.Count)
                  if (ajaxDone) ajaxDone(data)
                } catch(e) {
                  if (ajaxFail) ajaxFail(xhr, null, e)
                }
              } else {
                if (ajaxFail) ajaxFail(xhr)
              }
            }
            if (ajaxBeforeSend) ajaxBeforeSend(xhr)
            xhr.send(JSON.stringify(getRequestValue()))
        };
        this.getEntityAction = function () {
            var primaryEntityAction = primaryRequestItem.getEntityAction();
            return primaryEntityAction;
        };
        this.setEntityAction = function (queryEntityAction) {
            if (!queryEntityAction) {
                throw "A valid EntityAction is required for setEntityAction()";
            }
            var primaryEntityAction = primaryRequestItem.setEntityAction(queryEntityAction);
            return primaryEntityAction;
        };
        this.getEntityType = function () {
            return entityType;
        };
        this.setEntityType = function (queryEntityType) {
            if (!queryEntityType) {
                throw "A valid EntityType is required for setEntityType()";
            }
            else {
                //ToDo: make sure that only valid entity contexts are used
                //ToDo: how to set and validate every Request in the RequestList and not just primary
                primaryRequestItem.setEntityType(queryEntityType);
                //For the URL
                entityType = queryEntityType;
                setUrl();
                return entityType;
            }
        };
        this.addFilterItem = function (filterIn, groupIndex) {
            primaryRequestItem.addFilterItem(filterIn, groupIndex);
            var primaryFilterList = primaryRequestItem.getFilterModel();
            return primaryFilterList;
        };
        this.removeFilterItem = function (filterIn, groupIndex) {
            primaryRequestItem.removeFilterItem(filterIn, groupIndex);
            var primaryFilterList = primaryRequestItem.getFilterModel();
            return primaryFilterList;
        };
        this.getFilterModel = function () { //Can only be used to get the Primary Filter List
            var primaryFilterList = primaryRequestItem.getFilterModel();
            return primaryFilterList;
        };
        this.clearFilter = function () {
            primaryRequestItem.clearFilter();
        };

        this.createFilterGroup = function (filterGroupLogic) {
            var newFilter = new Filter();
            newFilter.setFilterGroupLogic(filterGroupLogic);
            primaryRequestItem.getFilterGroups().push(newFilter);
            //var updatedFilterGroupList = primaryRequestItem.getFilterGroups();
            return primaryRequestItem.getFilterGroups().length - 1;
        };

        this.getFilterGroup = function (groupIndex) { //Can only be used to get
            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            var updatedFilterGroup = primaryRequestItem.getFilterGroup(n);

            return updatedFilterGroup;
        };

        this.getFilterGroups = function () { //Can only be used to get
            var updatedFilterGroupList = primaryRequestItem.getFilterGroups();
            return updatedFilterGroupList;
        };

        this.getFilterGroupJoinEntity = function (groupIndex) {
            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            var fg = primaryRequestItem.getFilterGroup(n);

            var joinEntity = fg.getFilterGroupJoinEntity(n);
            return joinEntity;
        };

        this.setFilterGroupJoinEntity = function (groupJoinEntityIn, groupIndex) {
            if(entityAction === "Search" && groupJoinEntityIn !== queryEntityTypeIn) {
                throw new Error('For Search, join entity has to be the same as main request entity. There is no need to set it.')
            }

            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            var fg = primaryRequestItem.getFilterGroup(n);
            var joinEntity = fg.setFilterGroupJoinEntity(groupJoinEntityIn, n);
            return joinEntity;
        };

        /**GroupBy section for Primary Request Item*/
        this.addGroupBy = function (groupByIn) {
            throw "addGroupBy() is deprecated and replaced with addSelectItem(), please update your code";
            primaryRequestItem.addGroupBy(groupByIn);
            var primaryGroupByList = primaryRequestItem.getGroupByListModel();
            return primaryGroupByList;
        };
        this.removeGroupBy = function (groupByIn) {
            throw "removeGroupBy() is deprecated and replaced with removeSelectItem(), please update your code";
            primaryRequestItem.removeGroupBy(groupByIn);
            var primaryGroupByList = primaryRequestItem.getGroupByListModel();
            return primaryGroupByList;
        };
        this.getGroupByModel = function () { //Can only be used to get the Primary GroupBy List
            throw "getSelectListModel() is deprecated and replaced with getSelectListModel(), please update your code";
            var primaryGroupByList = primaryRequestItem.getGroupByListModel();
            return primaryGroupByList;
        };
        this.clearGroupBy = function () {
            throw "clearGroupBy() is deprecated and replaced with clearSelectList(), please update your code";
            primaryRequestItem.clearGroupBy();
        };


        //Patch 3.0.2 changing name from GroupByList to SelectList
        this.addSelectItem = function (groupByIn) {
            primaryRequestItem.addSelectItem(groupByIn);
            var primaryGroupByList = primaryRequestItem.getSelectListModel();
            return primaryGroupByList;
        };
        this.removeSelectItem = function (groupByIn) {
            primaryRequestItem.removeSelectItem(groupByIn);
            var primaryGroupByList = primaryRequestItem.getSelectListModel();
            return primaryGroupByList;
        };
        this.getSelectListModel = function () { //Can only be used to get the Primary GroupBy List
            var primaryGroupByList = primaryRequestItem.getSelectListModel();
            return primaryGroupByList;
        };
        this.clearSelectList = function () {
            primaryRequestItem.clearSelectList();
        };

        /***/
        this.getQ = function () {
            var q = primaryRequestItem.getQ();
            return q;
        };
        this.setQ = function (queryQ) {
            if (!queryQ) {
                throw "A valid string is required for setQ()";
            }
            else {
                var q = primaryRequestItem.setQ(queryQ);
                setUrl();
                return q;
            }
        };

        this.getRelatedEntities = function () {
            return primaryRequestItem.getRelatedEntities();
        };
        this.setRelatedEntities = function (relEnts) {
            return primaryRequestItem.setRelatedEntities(relEnts);
        };


        this.setLocationFilter = function (latitude, longitude, radiusIn, radiusUnitIn) {
            var radiusItems = primaryRequestItem.setLocationFilter(latitude, longitude, radiusIn, radiusUnitIn);

            return radiusItems;
        };

        this.getLocationFilter = function () {
            var radiusItems = primaryRequestItem.getLocationFilter();

            return radiusItems;
        };

        this.getPageModel = function () {
            return pagination;
        };
        this.requestPage = function () {
            getNewPageAjax();
        };
        this.getPageRows = function () {
            var rowsPerPage = pagination.getPageRows();
            return rowsPerPage;
        };
        this.setPageRows = function (queryRowsPerPage) {
            if (!queryRowsPerPage) {
                throw "A valid number is required for setPageRows()";
            }
            else { //set
                pagination.setPageRows(queryRowsPerPage);
                var rowsPerPage = pagination.getPageRows();
                setUrl();
                return rowsPerPage;
            }
        };
        this.getPageStart = function () {
            var start = pagination.getPageStart();
            return start;
        };
        this.setPageStart = function (queryStart) {
            if (!queryStart) {
                throw "A valid number is required for setPageStart()";
            }
            else { //set
                pagination.setPageStart(queryStart);
                var start = pagination.getPageStart();
                setUrl();
                return start;
            }
        };
        this.getSortOrderModel = function () {
            return orderByList;
        };
        this.setSortOrderSelected = function (selectedValues) {
            if (typeof selectedValues === "undefined") {
                throw "setSelected requires an array of objects {direction, propertyName}";
            } else {
                orderByList.setSelected(selectedValues);
                return selectedValues;
            }
        };
        this.clearSortOrder = function () {
            orderByList.clearSortOrder();
        };
        this.addSortOrderItem = function (propertyNameIn, directionIn) {
            orderByList.addSortOrderItem(propertyNameIn, directionIn);
            return orderByList;
        };
        this.removeSortOrderItem = function (propertyNameIn) {
            orderByList.removeSortOrderItem(propertyNameIn);
            return orderByList;
        };
        this.getUrl = function () { //Can only be used to get
            setUrl();
            return url;
        };
        this.getUrlBase = function () {
            return urlBase;
        };
        this.setUrlBase = function (queryUrlBase) {
            if (!queryUrlBase) {
                throw "A valid urlBase is required for setApiKey()";
            }
            else {
                urlBase = queryUrlBase;
                setUrl();
                return urlBase;
            }
        };
        /**Used for POST body to fetch data*/
        this.getRequestValue = function () {
            var value = {};
            value = getRequestValue();
            return value;
        };
        this.getResponseValue = function () {
            return kdResponse;
        };
        this.reset = function () {
            init();
            return url;
        };

        /**Bootstrap the closure*/
        init();

    };
})();

/**kd.api.data.RequestItem always lives in context of its parent kd.api.data.Request*/
var RequestItem = (function () {
    return function (queryEntityActionIn) {
        //Private Variables
        /**The entity type that is being requested
        * comes from the kd.api.data.Request parent object*/
        //var entityType = queryEntityTypeIn;
        /**The action that is being requested - Search|Group|Select
         * set in the init() so we can validate*/
        var entityAction;
        /**see kd.api.data.FilterItem.js
        * A list of Filters to be posted to Kd API
        */
        var defaultFilterGroup = new Filter();

        var filterGroupList = [];
        filterGroupList.push(defaultFilterGroup);

        var relatedEntities = null;

        /**see kd.api.data.GroupBy.js
         * A list of Grouping to be posted to Kd API GroupBy
         */
        var groupByList = new GroupByList();

        var q = "";
        var location;
        var lat;
        var lng;
        var distance;
        var unit;

        var errorCheckEntityAction = function (entityActionToCheck){
            if (_.indexOf(["Search", "Group", "Select"], entityActionToCheck) === -1) {
                throw entityActionToCheck + " is not a valid API Action.  Valid Actions are Search|Group|Select. In kd.js 3.0 we changed signature to be kd.Request(EntityType, Action) a reversal of old constructor kd.Request(Action, EntityType)";
            }
        };

        var setEntityAction = function (queryEntityAction) {
            errorCheckEntityAction(queryEntityAction);
            entityAction = queryEntityAction;
            return entityAction;
        };

        var init = function() {
            setEntityAction(queryEntityActionIn);
        };

        //Public Variables
        //None for this closure

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.getEntityAction = function () {
            return entityAction;
        };
        this.setEntityAction = function (queryEntityAction) {
            setEntityAction(queryEntityAction);
            return entityAction;
        };
        this.getRelatedEntities = function() {
          return relatedEntities;
        };
        this.setRelatedEntities = function(relEnts) {
          if (!Array.isArray(relEnts)) {
            throw "Please provide an array of related entities";
          }
          relatedEntities = relEnts;
          return relatedEntities;
        };
        this.getQ = function () {
            return q;
        };
        this.setQ = function (queryQ) {
            if (!queryQ) {
                throw "A valid string is required for setQ()";
            }
            else {
                q = queryQ;
                return q;
            }
        };
        this.setLocationFilter = function (latitude, longitude, radiusIn, radiusUnitIn) {
            if (!(typeof(latitude) === "number" && latitude >= -90 && latitude <= 90)){
                throw "A valid latitude is required - a number between -90 and 90";
            }
            if (!(typeof(longitude) === "number" && longitude >= -180 && longitude <= 180)){
                throw "A valid longitude is required - a number between -180 and 180";
            }
            if (!(typeof(radiusIn) === "number" && radiusIn > 0)){
                throw "A valid radius is required - a number > 0";
            }
            if (!(typeof(radiusUnitIn) === "string") || (_.indexOf(["Mile", "Kilometer"], radiusUnitIn) === -1)){
                throw "A valid radius unit is required: Mile, Kilometer";
            }
            lat = latitude;
            lng = longitude;
            distance = radiusIn;
            unit = radiusUnitIn;

            return {lat: lat, lng: lng, distance: radiusIn, unit: radiusUnitIn};
        };

        this.getLocationFilter = function () {
            return {lat: lat, lng: lng, distance: distance, unit: unit};
        };

        this.getFilterModel = function () { //Can only be used to get
            return defaultFilterGroup;
        };


        this.createFilterGroup = function (filterGroupLogic, filterGroupJoinEntity) {
            var newFilter = new Filter();
            newFilter.setFilterGroupLogic(filterGroupLogic);
            if (filterGroupJoinEntity){
                newFilter.setFilterGroupJoinEntity(filterGroupJoinEntity);
            }
            filterGroupList.push(newFilter);
            return filterGroupList;
        };

        this.getFilterGroup = function (groupIndex) { //Can only be used to get
            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            return filterGroupList[n];
        };

        this.getFilterGroups = function () { //Can only be used to get

            return filterGroupList;
        };

        this.clearFilter = function () {
            defaultFilterGroup.clearFilter();
        };
        this.addFilterItem = function (filterIn, groupIndex) {
            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            var fg = filterGroupList[n].addFilterItem(filterIn);
            return fg;
        };
        this.removeFilterItem = function (filterIn, groupIndex) {
            var n = 0;
            if(typeof groupIndex === "number"){
                n = groupIndex;
            }
            var fg = filterGroupList[n].removeFilterItem(filterIn);
            return fg;
        };



        this.getGroupByListModel = function () { //Can only be used to get
            throw "getGroupByListModel() is deprecated and replaced with getSelectListModel(), please update your code";
            return groupByList;
        };

        this.clearGroupBy = function () {
            throw "clearGroupBy() is deprecated and replaced with clearSelectList(), please update your code";
            groupByList.clearGroupBy();
        };
        this.addGroupBy = function (groupByIn) {
            throw "addGroupBy() is deprecated and replaced with addSelectItem(), please update your code";
            groupByList.addGroupBy(groupByIn);
            return groupByList;
        };
        this.removeGroupBy = function (groupByIn) {
            throw "removeGroupBy() is deprecated and replaced with removeSelectItem(), please update your code";
            groupByList.removeGroupBy(groupByIn);
            return groupByList;
        };

        //Patch 3.0.2 changing name from GroupByList to SelectList
        this.getSelectListModel = function () { //Can only be used to get
            return groupByList;
        };

        this.clearSelectList = function () {
            groupByList.clearSelectList();
        };
        this.addSelectItem = function (columnIn) {
            groupByList.addSelectItem(columnIn);
            return groupByList;
        };
        this.removeSelectItem = function (columnIn) {
            groupByList.removeSelectItem(columnIn);
            return groupByList;
        };


        this.getRequestItemValue = function (requestEntityType) {
            var value = {};
            //value.EntityType = entityType;
            value.KdEntityAction = entityAction;
            value.Q = q;
            value.Lat = lat;
            value.Lng = lng;
            value.Distance = distance;
            value.Unit = unit;
            value.FilterGroups = [];

            _.each(filterGroupList, function (fGroup, index) {
                if (fGroup) {
                    var filterListStruct = fGroup.getFilterValue();
                    var fGroupJson = {};
                    fGroupJson.Filters = filterListStruct;
                    fGroupJson.Logic = fGroup.getFilterGroupLogic();
                    if(filterListStruct && filterListStruct.length >0){
                        //If the FilterGroup exists and has Filters, check for validity
                        if(entityAction === "Search"){
                            fGroupJson.JoinEntity = requestEntityType;
                        } else {
                            fGroupJson.JoinEntity = fGroup.getFilterGroupJoinEntity();
                        }

                    }
                    if (index === 0 || (filterListStruct && filterListStruct.length >0)) {
                        value.FilterGroups.push(fGroupJson);
                    }

                }

            });

            // if (filterGroup) {
            //     var filterListStruct = filterGroup.getFilterValue();
            //     value.KdFilterList = filterListStruct;
            // }

            if (groupByList) {
                var groupByListStruct = groupByList.getGroupByValue();
                // value.GroupByList = groupByListStruct; //deprecated
                value.SelectList = groupByListStruct;

            }

            if (relatedEntities) {
              value.RelatedEntities = relatedEntities;
            }


            return value;
        };

        /**Bootstrap the closure*/
        init();
    };
})();

var RequestItemList = (function () {
    return function (queryEntityTypeIn) {
        //Private Variables
        var requestItemList = [];

        //Private Functions
        var getRequestItemListValues = function () {
            var requests = [];
            _.each(requestItemList, function (request, index) {
                var selectedValue = request.getRequestItemValue(queryEntityTypeIn);
                selectedValue.EntityType = queryEntityTypeIn;
                requests.push(selectedValue);

            });
            return requests;
        }
        var rejectRequestItem = function (requestItemIn) {
            return !requestItemIn; //for now just return true or false if filter is null
        }

        //Public Variables
        //None for this closure

        //Privileged functions, can access both public and private
        //We need functions here to do protected get and set
        //and to do error checking and handling
        this.addRequestItem = function (requestItemIn) {
            if (rejectRequestItem(requestItemIn)) return "A valid Kd Request Item is required";
            else {
                requestItemList.push(requestItemIn);
                return requestItemList;
            }
        };
        this.removeRequestItem = function (requestItemIn) {
            _.each(requestItemList, function (request, index) {
                if (request === requestItemIn) {
                    requestItemList.splice(index,1);//Get rid of matching item
                    return false; //break the loop

                }
                return true; //continue the loop

            });
            return requestItemList;
        };
        this.getRequestItemList = function () {
            return requestItemList;
        };
        this.getRequestItemListValue = function () {
            var requestListStruct = getRequestItemListValues();
            return requestListStruct;
        };
        this.clearRequestItemList = function () {
            requestItemList = [];
        };


    };
})();

exports.Request = Request
exports.RequestItem = RequestItem
exports.RequestItemList = RequestItemList



//////////////////
// WEBPACK FOOTER
// ./~/karmadata/kd.api.data/kd.api.data.Request.js
// module id = 205
// module chunks = 0